function browser_name() {
	var userAgent = window.navigator.userAgent.toLowerCase();
	var appVersion = window.navigator.appVersion.toLowerCase();

	if (userAgent.indexOf("msie") > -1) {
		if (appVersion.indexOf("msie 6.0") > -1) {
			//alert("IE6");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 7.0") > -1) {
			//alert("IE7");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 8.0") > -1) {
			//alert("IE8");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 9.0") > -1) {
			//alert("IE9");
			$('html').addClass('isIE');
		} else if (appVersion.indexOf("msie 10.0") > -1) {
			//alert("IE10");
		} else {
			//alert("Unknown");
		}
	} else if (userAgent.indexOf("trident/7.0") > -1) {
		//alert("IE11");
		$('html').addClass('isIE');
	} else if (userAgent.indexOf("edge") > -1) {
		//alert("Edge");
		$('html').addClass('isEdge');
	} else if (userAgent.indexOf("firefox") > -1) {
		//alert("Firefox");
	} else if (userAgent.indexOf("opera") > -1) {
		//alert("Opera");
	} else if (userAgent.indexOf("chrome") > -1) {
		//alert("Google Chrome");
	} else if (userAgent.indexOf("safari") > -1) {
		//alert("Safari");
	} else {
		//alert("Unknown");
	}
}


browser_name();


// PC / SP判定
if ((navigator.userAgent.indexOf('iPhone') > 0 && navigator.userAgent.indexOf('iPad') == -1) || navigator.userAgent.indexOf('iPod') > 0 || navigator.userAgent.indexOf('Android') > 0) {
	// スマホ時に行う処理を書く
} else {
	// PC・タブレット時に行う処理を書く
}

// 画面サイズ判定
var windowWidth = $(window).width();
var windowsm = 640;
if (windowWidth <= windowsm) {
	//横幅640px以下のとき（つまりスマホ時）に行う処理を書く
} else {
	//横幅640px超のとき（タブレット、PC）に行う処理を書く
}

// iOSのバージョン判断
function ios_ver() {
	var ios_ua = navigator.userAgent;
	if (ios_ua.indexOf("iPhone") > 0) {
		ios_ua.match(/iPhone OS (\w+){1,3}/g);
		var version = (RegExp.$1.replace(/_/g, '') + '00').slice(0, 3);
		return version;
	}
}

// Androidのバージョン判断
function and_ver() {
	var and_ua = navigator.userAgent;
	if (and_ua.indexOf("Android") > 0) {
		var version = parseFloat(and_ua.slice(and_ua.indexOf("Android") + 8));
		return version;
	}
}

// -------------------------------------------------------------------
// htmlタグに以下のブラウザ判別用クラスを追加します
// -------------------------------------------------------------------
// https://kantaro-cgi.com/blog/javascript/add_class_every_browsers.html
// htmlタグに以下のブラウザ判別用クラスを追加します。
// 例えばIE6なら <html class="ie ie6"> となります。
// 対象：ie, chrome, firefox, oepra, sagari
// ※一応将来のバージョンにも対応してるのでIE99でも「class="ie ie99"」となります。
// ※ブラウザ名は全て小文字指定、バージョン指定の部分は、最初のマイナーバージョンまで、小数点の0のみはピリオドごと消える、「.」は「_」になる。
// 例：「Safari」→「safari」
// 例：「IE11.0」→「ie11」
// 例：「IE5.5」→「ie5_5」
// 例：「Safari5.1.7」→「safari5_1」

function addBrowserClass() {
	var __add = function(name, ver) {
		if (document.documentElement.className) {
			document.documentElement.className += ' ';
		}
		document.documentElement.className += name + (ver != '' ? ' ' + name + (ver * 1).toString().replace('.', '_') : '');
	}
	var userAgent = window.navigator.userAgent.toLowerCase();
	var appVersion = window.navigator.appVersion.toLowerCase();
	if (get = userAgent.match(/msie (\d+(\.\d+)?)/i)) {
		__add('ie', get[1]);
	} else if (get = userAgent.match(/Trident.+rv\:(\d+(\.\d+)?)/i)) {
		__add('ie', get[1]);
	} else if (get = userAgent.match(/chrome\/(\d+(\.\d+)?)/i)) {
		__add('chrome', get[1]);
	} else if (get = userAgent.match(/firefox\/(\d+(\.\d+)?)/i)) {
		__add('firefox', get[1]);
	} else if (get = userAgent.match(/opera\/(\d+(\.\d+)?)/i)) {
		__add('opera', get[1]);
	} else if (get = userAgent.match(/safari\/(\d+(\.\d+)?)/i)) {
		__add('safari', get[1]);
	}

	// ついでにモバイルOS情報を付加する→ios(iphone, ipad, ipod), android
	if (get = userAgent.match(/iPhone OS (\d+(\.\d+)?)/i)) {
		__add('ios', get[1]);
	}
	if (get = userAgent.match(/iPhone;/i)) {
		__add('iphone', '');
	} else if (get = userAgent.match(/iPod;/i)) {
		__add('ipod', '');
	} else if (get = userAgent.match(/iPad;/i)) {
		__add('ipad', '');
	} else if (get = userAgent.match(/Android (\d+(\.\d+)?)/i)) {
		__add('android', get[1]);
	}
}
addBrowserClass();








var os, ua = navigator.userAgent;

if (ua.match(/Win(dows )?NT 10\.0/)) {
	os = "windows"; // windows 10 の処理 (windows Server 2016, windows Server 2019)
} else if (ua.match(/Win(dows )?NT 6\.3/)) {
	os = "windows"; // windows 8.1 の処理 (windows Server 2012 R2)
} else if (ua.match(/Win(dows )?NT 6\.2/)) {
	os = "windows"; // windows 8 の処理 (windows Server 2012)
} else if (ua.match(/Win(dows )?NT 6\.1/)) {
	os = "windows"; // windows 7 の処理 (windows Server 2008 R2, windows Home Server 2011)
} else if (ua.match(/windows Phone/)) {
	os = "windowsphone"; // windows Phone (windows 10 Mobile) の処理


} else if (ua.match(/iPhone|iPad/)) {
	os = "ios"; // iOS (iPhone, iPod touch, iPad) の処理

} else if (ua.match(/Mac|PPC/)) {
	os = "macos"; // Macintosh の処理

} else if (ua.match(/Android ([\.\d]+)/)) {
	os = "android " + RegExp.$1; // Android の処理
} else if (ua.match(/Linux/)) {
	os = "linux"; // Linux の処理
} else if (ua.match(/^.*\s([A-Za-z]+BSD)/)) {
	os = RegExp.$1; // BSD 系の処理
} else if (ua.match(/SunOS/)) {
	os = "solaris"; // Solaris の処理
} else {
	os = "N/A"; // 上記以外 OS の処理
}
console.log(os);
$('html').addClass(os)
// document.write("あなたは " + os + " を使用されています。");

document.createElement("picture");
svg4everybody();

jQuery(function($) {
	objectFitImages('.object-fit');

	// $('.js-marquee').infiniteslide({
	// 	pauseonhover: false,
	// 	speed: 500,
	// 	responsive: false,
	// 	// clone: 1
	// });
	//
	$(window).on('load', function() {
		var rellax = new Rellax('.rellax', {
			center: true,
		});
	});





	let maxSlideNum = 0,
		thisSlideIndex = 0;


	var slideCount = $('.swiper-slide').length;
	let slideCountTwo = slideCount.toString().padStart(2, '0');
	// console.log(slideCountTwo);
	$('.js-count span').append(slideCountTwo)

	var swiper = new Swiper(".mySwiper", {
		loop: true,
		effect: 'fade',
		speed: 2000,
		autoplay: {
			delay: 3500,
		},
		slidesPerView: 1,
		spaceBetween: 0,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		on: {
			init: function() {
				// Swiper起動時に実行される
				let slideNum = []; // スライドの最大枚数を取得するための配列
				/*
				  下記の繰り返しで swiper-slide の data属性に付与されている swiper-slide-index を取得して
				  配列に格納していく、 Math.maxで配列の中に格納されている数値の中で一番数が大きいものを maxSlideNum に入れる
				*/
				let slideLength = document.querySelectorAll('.swiper-container .swiper-slide').length;
				// loop が true かチェックする
				// loop が true の場合、loopedSlidesが1になるのでこの分岐で確認が出来る false の場合は undefined が返ってくる
				if (this.loopedSlides) {
					for (let i = 0; i < slideLength; i++) {
						slideNum.push(document.querySelector('.swiper-container').getElementsByClassName('swiper-slide')[i].dataset.swiperSlideIndex);
						maxSlideNum = Math.max(...slideNum) + 1;
					}
				} else {
					maxSlideNum = slideLength;
				}
				// スライドの最大枚数を出力
				// document.querySelector('.js-Maxnum').innerHTML = maxSlideNum;
				// 最初の数値を出力（スライドの初期位置が違う場合は、ここを変更する）
				document.querySelector('.js-currentNum').innerHTML = 1;
			},
			transitionStart: function() {
				/*
				 * スライドが切り替わった時に実行される
				 * インデックスは 0 スタートなので 1 を足した数値にする
				 */

				thisSlideIndex = [].slice.call(document.querySelector('.swiper-pagination').querySelectorAll('.swiper-pagination-bullet')).indexOf(document.querySelector('.swiper-pagination-bullet-active')) + 1;
				thisSlideIndex = thisSlideIndex.toString().padStart(2, '0');

				document.querySelector('.js-currentNum').innerHTML = thisSlideIndex;
				$('.js-slidenumber').attr('data-slidenumber', thisSlideIndex);

			},
		}
	});



	// let SwiperTop = new Swiper('.js-marquee02', {
	// 	spaceBetween: 0,
	// 	centeredSlides: true,
	// 	speed: 6000,
	// 	autoplay: {
	// 		delay: 1,
	// 	},
	// 	loop: true,
	// 	slidesPerView: 'auto',
	// 	allowTouchMove: false,
	// 	disableOnInteraction: true
	// });
	// let SwiperBottom = new Swiper('.js-marquee02', {
	// 	spaceBetween: 0,
	// 	centeredSlides: true,
	// 	speed: 3000,
	// 	autoplay: {
	// 		delay: 1,
	// 		// reverseDirection: true
	// 	},
	// 	loop: true,
	// 	// loopedSlides: 4,
	// 	slidesPerView: 4,
	// 	allowTouchMove: false,
	// 	disableOnInteraction: true
	// });



});

$(window).on('load', function() {
	$('html').addClass('is-loaded');
});

// ===========================
// youtube api
// ===========================

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var youtubeData = [{
	youtubeIid: 'vCt0MUClUfE',
	embedArea: 'ytVideo1'
}, {
	youtubeIid: 'pV-ojdOqjPA',
	embedArea: 'ytVideo2'
}, {
	youtubeIid: 'oqZLskWdMyo',
	embedArea: 'ytVideo3'
}, {
	youtubeIid: 'htf4cu7D75o',
	embedArea: 'ytVideo4'
}];

function onYouTubeIframeAPIReady() {
	for (var i = 0; i < youtubeData.length; i++) {
		// document.getElementById(youtubeData[i]['embedArea']).innerHTML = '<img id="yt-thumb' + i + '" src="http://i.ytimg.com/vi/' + youtubeData[i]['youtubeIid'] + '/sddefault.jpg">';
		embedYoutube(i);
	}
}

// YouTubeの埋め込みの準備
var ytPlayer;

function embedYoutube(num) {
	// サムネイルクリックでYouTubeを埋め込むようにする
	// document.getElementById('yt-thumb' + num).addEventListener('click', function() {
	ytPlayer = new YT.Player(
		youtubeData[num]['embedArea'], // 埋め込む場所の指定
		{
			height: '360',
			width: '640',
			videoId: youtubeData[num]['youtubeIid'], // YouTubeのID
			playerVars: {
				controls: 0,
				showinfo: 0,
				disablekb: 1,
				rel: 0
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		}
	);
	// });
}

function onPlayerReady(event) {
	event.target.mute();
	event.target.playVideo();
}

// スムーズloop
var loopCount = 0;

function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.ENDED) { //動画が停止したら
		if (loopCount < 99999999999) { //ループ上限
			event.target.seekTo(0, true); //動画の初めにシーク
			event.target.playVideo(); //動画を再生
			loopCount++;
		}
	}
}
